import { faBarcode } from "@fortawesome/free-solid-svg-icons";
import { Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    AlterarClassificacaoClienteController,
    ExcluirContratosEmMassaController,
    ExportarContratosDistribuidosController,
    ExportarContratosNaoDistribuidosController,
    ListarContratosDistribuidosController,
    ListarContratosDistribuidosPorGruposController,
    ListarContratosNaoDistribuidosController,
} from "../../../Controllers/Cobranca/DistribuicaoCarteira/DistribuicaoCarteiraControllers";
import {
    IContrato,
    IListaGrupoContrato,
} from "../../../Interfaces/Cobranca/Contrato/ContratoInterfaces";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import SpinnerComponent from "../../../Components/Loding/Spinner";
import ExportExcel from "../../../Components/StickyToolbar/ExportExcel";
import { useCallback, useState } from "react";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import AssociarContrato from "./ModalAssociarContrato";
import ModalComponent from "../../../Components/Modais";
import { ListarClassificacaoCobrancaController } from "../../../Controllers/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaController";
import TableNaoDistribuidos from "./TableNaoDistribuidos";
import TableDistribuidos from "./TableDistribuidos";
import TableManualCliente from "./TableManualCliente";

export default function GestaoCarteiraCobranca() {
    const { value: lstContratosDistribuidos, ...ListarContratosDistribuidos } =
        useAsyncEffect(ListarContratosDistribuidosController);
    const {
        value: lstContratosDistribuidosPorGrupo,
        ...ListarContratosDistribuidosPorGrupo
    } = useAsyncEffect(ListarContratosDistribuidosPorGruposController);
    const {
        value: lstContratosNaoDistribuidos,
        ...ListarContratosNaoDistribuidos
    } = useAsyncEffect(ListarContratosNaoDistribuidosController);
    const ExportarContratosDistribuidos = useAsyncCallback(
        ExportarContratosDistribuidosController
    );
    const ExportarContratosNaoDistribuidos = useAsyncCallback(
        ExportarContratosNaoDistribuidosController
    );
    const ListarClassificacaoCobranca = useAsyncCallback(
        ListarClassificacaoCobrancaController
    );

    const {
        execute: ExcluirContratosEmMassa,
        loading: ExcluirContratosEmMassaLoading,
    } = useAsyncCallback(ExcluirContratosEmMassaController);

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    let filterValueContratos: object[] = lstContratosDistribuidos ?? [];

    const [lstSelecionados, setlstSelecionados] = useState<Array<IContrato>>(
        []
    );

    const [lstSelecionadosDistribuidos, setlstSelecionadosDistribuidos] =
        useState<IListaGrupoContrato>();

    function handleExcluirContratosEmMassa() {
        if (lstSelecionadosDistribuidos?.Contratos) {
            ExcluirContratosEmMassa(
                lstSelecionadosDistribuidos?.Contratos.map(
                    (contratos) => contratos.ID_CASO_COBRANCA_FILA_ATENDIMENTO
                )
            ).then(() => {
                setlstSelecionadosDistribuidos({
                    Contratos: [],
                    DS_GRUPO: "",
                    ID_GRUPO: 0,
                    QNT_CONTRATOS: 0,
                    VALOR_TOTAL: 0,
                });
                ListarContratosDistribuidosPorGrupo.execute();
            });
        }
    }

    const handleSubmitClassificacao = useCallback(
        (idClassificacao, ID_CHAVE_ERP) => {
            ListarClassificacaoCobranca.execute().then((res) => {
                const findClassificacao: any = res.find(
                    (classificacao) =>
                        classificacao.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA ===
                        idClassificacao
                );
                AlterarClassificacaoClienteController({
                    DS_CLASSIFICACAO_CONTRATO:
                        findClassificacao?.DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA,
                    ID_CHAVE_ERP: ID_CHAVE_ERP,
                }).then(() => {
                    ListarContratosDistribuidosPorGrupo.execute();
                    setShow(false);
                });
            });
        },
        [ListarClassificacaoCobranca, ListarContratosDistribuidosPorGrupo]
    );

    //tabela

    return (
        <>
            <div style={{ minHeight: "350px" }} className="card card-custom">
                <Tabs
                    defaultActiveKey="home"
                    transition={false}
                    id="noanim-tab-example"
                    className="mb-3 ml-5 mt-2 d-flex"
                >
                    <Tab eventKey="home" title="Distribuídos">
                        <div className="card-body mt-n5 table-responsive">
                            {lstContratosDistribuidosPorGrupo ? (
                                <TableDistribuidos
                                    filterValueContratos={filterValueContratos}
                                    ListarContratosDistribuidosPorGrupo={
                                        ListarContratosDistribuidosPorGrupo
                                    }
                                    lstSelecionadosDistribuidos={
                                        lstSelecionadosDistribuidos
                                    }
                                    handleExcluirContratosEmMassa={
                                        handleExcluirContratosEmMassa
                                    }
                                    ExcluirContratosEmMassaLoading={
                                        ExcluirContratosEmMassaLoading
                                    }
                                    setModal={setModal}
                                    handleSubmitClassificacao={
                                        handleSubmitClassificacao
                                    }
                                    setShow={setShow}
                                    ListarContratosDistribuidos={
                                        ListarContratosDistribuidos
                                    }
                                    ListarContratosNaoDistribuidos={
                                        ListarContratosNaoDistribuidos
                                    }
                                    setlstSelecionados={setlstSelecionados}
                                    lstContratosDistribuidosPorGrupo={
                                        lstContratosDistribuidosPorGrupo
                                    }
                                    setlstSelecionadosDistribuidos={
                                        setlstSelecionadosDistribuidos
                                    }
                                />
                            ) : (
                                // <Table
                                //     columns={geradorDeColunasPorGrupo()}
                                //     data={lstContratosDistribuidosPorGrupo}
                                //     expandRow={expandRow}
                                //     keyField="ID_GRUPO"
                                //     classes="v-middle-cells"
                                //     loading={
                                //         ListarContratosDistribuidosPorGrupo.loading
                                //     }
                                //     noDataIndication={
                                //         <div className="text-center text-black-50">
                                //             Nenhum contrato distribuído
                                //             encontrado
                                //         </div>
                                //     }
                                //     striped={true}
                                //     bordered={true}
                                // />
                                ListarContratosDistribuidosPorGrupo.loading && (
                                    <SpinnerComponent />
                                )
                            )}
                        </div>
                        <ExportExcel
                            baixarExcelController={async () =>
                                ExportarContratosDistribuidos.execute()
                            }
                            nomeArquivo={`Contratos_Distribuidos`}
                        />
                    </Tab>
                    <Tab eventKey="profile" title="Não Distribuídos">
                        <div className="card-body mt-n5">
                            <button
                                disabled={lstSelecionados.length <= 0}
                                className="btn btn-sm btn-shadow btn-primary d-flex align-items-center flex-nowrap w-10 mb-4"
                                type="button"
                                onClick={() => {
                                    setShow(true);
                                    setModal({
                                        Children: (
                                            <AssociarContrato
                                                setShow={setShow}
                                                lstCasoCobrancaFato={
                                                    lstSelecionados
                                                }
                                                update={() => {
                                                    ListarContratosDistribuidos.execute();
                                                    ListarContratosDistribuidosPorGrupo.execute();
                                                    ListarContratosNaoDistribuidos.execute();
                                                    setlstSelecionados([]);
                                                }}
                                            />
                                        ),
                                        noHeader: true,
                                        noFooter: true,
                                    });
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={faBarcode}
                                    size="lg"
                                    className="mr-2"
                                />{" "}
                                Associar Contratos Selecionados
                            </button>
                            {lstContratosNaoDistribuidos ? (
                                <TableNaoDistribuidos
                                    lstContratosNaoDistribuidos={
                                        lstContratosNaoDistribuidos
                                    }
                                    lstSelecionados={lstSelecionados}
                                    setlstSelecionados={setlstSelecionados}
                                    ListarContratosNaoDistribuidos={
                                        ListarContratosNaoDistribuidos
                                    }
                                />
                            ) : (
                                ListarContratosNaoDistribuidos.loading && (
                                    <SpinnerComponent />
                                )
                            )}
                        </div>
                        <ExportExcel
                            baixarExcelController={async () =>
                                ExportarContratosNaoDistribuidos.execute()
                            }
                            nomeArquivo={`Contratos_Nao_Distribuidos`}
                        />
                    </Tab>
                    <Tab eventKey="ManualCliente" title="Manual do Cliente">
                        <div className="card-body mt-n5 table-responsive">
                            {lstContratosDistribuidosPorGrupo ? (
                                <TableManualCliente
                                    filterValueContratos={filterValueContratos}
                                    ListarContratosDistribuidosPorGrupo={
                                        ListarContratosDistribuidosPorGrupo
                                    }
                                    lstSelecionadosDistribuidos={
                                        lstSelecionadosDistribuidos
                                    }
                                    handleExcluirContratosEmMassa={
                                        handleExcluirContratosEmMassa
                                    }
                                    ExcluirContratosEmMassaLoading={
                                        ExcluirContratosEmMassaLoading
                                    }
                                    setModal={setModal}
                                    handleSubmitClassificacao={
                                        handleSubmitClassificacao
                                    }
                                    setShow={setShow}
                                    ListarContratosDistribuidos={
                                        ListarContratosDistribuidos
                                    }
                                    ListarContratosNaoDistribuidos={
                                        ListarContratosNaoDistribuidos
                                    }
                                    setlstSelecionados={setlstSelecionados}
                                    lstContratosDistribuidosPorGrupo={
                                        lstContratosDistribuidosPorGrupo
                                    }
                                    setlstSelecionadosDistribuidos={
                                        setlstSelecionadosDistribuidos
                                    }
                                />
                            ) : (
                                ListarContratosDistribuidosPorGrupo.loading && (
                                    <SpinnerComponent />
                                )
                            )}
                        </div>
                        <ExportExcel
                            baixarExcelController={async () =>
                                ExportarContratosDistribuidos.execute()
                            }
                            nomeArquivo={`Contratos_Distribuidos`}
                        />
                    </Tab>
                </Tabs>
                <ModalComponent
                    ModalComponent={modal}
                    setShow={setShow}
                    show={show}
                />
            </div>
        </>
    );
}
